import { getDeviceType } from '../../api/getDeviceType'
import { getCookie } from '../../browser'
import { getAppAgent } from '../../deviceType'
import { isEmpty } from '../../generalUtils'
import { getCurrentLocale } from '../getCurrentLocale'

const setCommonHeaders = (headers: Headers) => {
    const deviceType = getDeviceType()
    const appAgent = getAppAgent(deviceType)
    const locale = getCurrentLocale()

    headers.set('Accept', 'application/json')
    headers.set('Content-Type', 'application/json')
    headers.set('Cache-Control', 'no-cache')
    headers.set('Pragma', 'no-cache')
    headers.set('Expires', '0')
    headers.set('app-agent', appAgent)
    headers.set('Preferred-Language', locale)
    headers.set('Accept-Language', locale)
    headers.set('X_CT_SOURCETYPE', deviceType)
    headers.set('x-selected-country',getCookie('selected_country') || 'FOSA')

    if (typeof window !== 'undefined') {
        const androidData = (window as any).androidData
        const iosData = (window as any).iosData

        if (androidData && !isEmpty(androidData)) {
            Object.entries(androidData).forEach(([key, value]) => {
                headers.set(key, value as string)
            })
        }

        if (iosData && !isEmpty(iosData)) {
            Object.entries(iosData).forEach(([key, value]) => {
                headers.set(key, value as string)
            })
        }
    }

    return headers
}

export default setCommonHeaders
